import { IAppState } from "../index";

export const getBeverages = (state: IAppState) => state.beverages.beverages;

export const getBeveragesX10 = (state: IAppState) => state.beverages.beveragesX10;
